import {
  Directive,
  DoCheck,
  Input,
  ElementRef,
  Renderer2,
} from '@angular/core';
import { NgModel, UntypedFormControl } from '@angular/forms';
import { IAbstractControl } from '@rxweb/types/reactive-form/i-abstract-control';

@Directive({
  selector: '[podValidationClass]',
})
export class ValidationClassDirective implements DoCheck {
  @Input('podValidationClass') model:
    | NgModel
    | UntypedFormControl
    | IAbstractControl<any, any>;
  @Input() submitted?: boolean;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  ngDoCheck() {
    const element = this.elementRef.nativeElement;
    const className = 'was-validated';

    if (this.model) {
      if (
        (this.submitted ||
          (this.model instanceof NgModel &&
            this.model.formDirective.submitted) ||
          this.model.dirty ||
          this.model.touched) &&
        this.model.invalid
      ) {
        this.renderer.addClass(element, className);
      } else {
        this.renderer.removeClass(element, className);
      }
    }
  }
}
